import { withIcon } from "../Icon"

export const IconCrossCircle = withIcon(
  '<path fill="none" stroke="currentColor" stroke-linejoin="round" stroke-width="1.5" d="M12 20a7.974 7.974 0 0 0 5.657-2.343A7.974 7.974 0 0 0 20 12a7.976 7.976 0 0 0-2.343-5.657A7.975 7.975 0 0 0 12 4a7.975 7.975 0 0 0-5.657 2.343A7.975 7.975 0 0 0 4 12a7.974 7.974 0 0 0 2.343 5.657A7.974 7.974 0 0 0 12 20Z"/><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" d="m15 9-6 6m0-6 6 6"/>',
)
